import {
  CONTACT_ORIGIN,
  CONTACT_TYPE,
  IContactApiProps,
  IContactForm,
  IContactInteractionsApiProps,
  INTERACTION_TYPE,
} from '../repositories/IContact.repository';

export class ContactModel implements IContactModelProps {
  id: number;
  name: string;
  lastName?: string;
  type?: CONTACT_TYPE;
  origin?: CONTACT_ORIGIN;
  email?: string;
  phone?: string;
  countryCode?: string;
  phoneCode?: string;
  streetAddress?: string;
  city?: string;
  stateIso?: string;
  createdAt?: string;
  updatedAt?: string;

  constructor(data: IContactModelProps) {
    this.id = data.id;
    this.name = data.name;
    this.lastName = data.lastName || '';
    this.type = data.type || 'NOT_SPECIFIED';
    this.origin = data.origin || 'UNKNOWN';
    this.email = data.email || '';
    this.phone = (data.phone || '').replace(/[^0-9]+/g, '').slice(-10);
    this.countryCode = data.countryCode || 'MEX';
    this.phoneCode = data.phoneCode || '+52';
    this.streetAddress = data.streetAddress || '';
    this.city = data.city || '';
    this.stateIso = data.stateIso || '';
    this.createdAt = data.createdAt || '';
    this.updatedAt = data.updatedAt || '';
  }

  static toApiModel(
    contact: ContactModel,
    excludedFields: string[] = []
  ): IContactApiProps {
    const payload: IContactApiProps = {
      id: contact.id ? contact.id.toString() : null,
      name: contact.name,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      last_name: contact.lastName || '',
      type: contact.type || 'NOT_SPECIFIED',
      email: contact.email || '',
      phone: contact.phone || '',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      country_code: contact.countryCode,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      phone_code: contact.phoneCode,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      street_address: contact.streetAddress || '',
      city: contact.city || '',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      state_iso: contact.stateIso || '',

      // Maybe unused
      // eslint-disable-next-line @typescript-eslint/naming-convention
      client_id: null,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      full_name: null,
      origin: contact.origin,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      created_at: contact.createdAt,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      updated_at: contact.updatedAt,
    };

    excludedFields.forEach((f) => {
      // eslint-disable-next-line no-prototype-builtins
      if (payload.hasOwnProperty(f)) {
        delete payload[f];
      }
    });

    return payload;
  }

  static fromDataResponse(data: IContactApiProps): ContactModel {
    return new ContactModel({
      id: +data.id,
      name: data.name,
      lastName: data.last_name,
      type: data.type,
      origin: data.origin,
      email: data.email,
      phone: data.phone,
      countryCode: data.country_code,
      phoneCode: data.phone_code,
      streetAddress: data.street_address,
      city: data.city,
      stateIso: data.state_iso,
      createdAt: data.created_at,
      updatedAt: data.updated_at,
    });
  }

  static fromContactForm(form: IContactForm): ContactModel {
    return new ContactModel({
      // Required
      id: +form.id,
      name: form.name,
      countryCode: form.country_code,
      phoneCode: form.phone_code,

      lastName: form.last_name,
      type: form.type,
      phone: form.phone,
      email: form.email,
      streetAddress: form.street_address,
      city: form.city,
      stateIso: form.state_iso,
    });
  }

  static empty() {
    return new ContactModel({
      id: null,
      name: '',
      countryCode: null,
      phoneCode: null,
    });
  }
}

export interface IContactModelProps {
  // Required
  id: number;
  name: string;
  countryCode?: string;
  phoneCode?: string;

  // Main optionals
  lastName?: string;
  type?: CONTACT_TYPE;
  origin?: CONTACT_ORIGIN;
  email?: string;
  phone?: string;
  streetAddress?: string;
  city?: string;
  stateIso?: string;
  createdAt?: string;
  updatedAt?: string;
}

export class ContactInteractionModel implements IContactInteractionModelProps {
  id: number;
  contactId: number | string;
  entity: 'contacts';
  entityId: any;
  actionType: INTERACTION_TYPE;
  createdAt: string;
  displayText: string;

  constructor(data: IContactInteractionModelProps) {
    this.id = data.id;
    this.contactId = data.contactId;
    this.entity = data.entity;
    this.entityId = data.entityId;
    this.actionType = data.actionType;
    this.createdAt = data.createdAt;
    this.displayText = data.displayText || '';
  }

  static fromDataResponse(
    data: IContactInteractionsApiProps
  ): ContactInteractionModel {
    return new ContactInteractionModel({
      id: +data.id,
      contactId: +data.contact_id,
      entity: data.entity,
      entityId: data.entity_id,
      actionType: data.action_type,
      createdAt: data.created_at,
      displayText: data.display_text,
    });
  }

  static empty(): ContactInteractionModel {
    return new ContactInteractionModel({
      id: null,
      contactId: null,
      entity: null,
      entityId: null,
      actionType: null,
      createdAt: null,
      displayText: null,
    });
  }
}

export interface IContactInteractionModelProps {
  id: number;
  contactId: number | string;
  entity: 'contacts';
  entityId: number | string;
  actionType: INTERACTION_TYPE;
  createdAt: string;
  displayText: string;
}

/*export enum ContactInteractionTypes{
    CREATE,
    UPDATE_TYPE,
    WEBSITE_FORM,
    EVENT_INVITE,
    CREATE_NOTE,
    CONTACT_EMAIL,
    CONTACT_CALL,
    CONTACT_WHATSAPP
}*/
